var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0357 19.1834V8.27432H12.7119V19.1834H11.0357ZM11.888 6.45614C11.5613 6.45614 11.2796 6.34487 11.0428 6.12233C10.8108 5.89979 10.6948 5.63227 10.6948 5.31977C10.6948 5.00727 10.8108 4.73976 11.0428 4.51722C11.2796 4.29468 11.5613 4.18341 11.888 4.18341C12.2147 4.18341 12.494 4.29468 12.7261 4.51722C12.9628 4.73976 13.0812 5.00727 13.0812 5.31977C13.0812 5.63227 12.9628 5.89979 12.7261 6.12233C12.494 6.34487 12.2147 6.45614 11.888 6.45614Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0016,
    cy: 12.1834,
    r: 11.4375,
    stroke: "#1A1B1D",
    strokeWidth: 1.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLine);
export default __webpack_public_path__ + "static/media/info_line.6d3ec354.svg";
export { ForwardRef as ReactComponent };